import React from 'react';
import type { ReturnOrder } from '../returnsTypes';
import styles from './ReturnQueue.module.css';

interface ReturnQueueProps {
  orders: ReturnOrder[];
  onSelectReturn: (returnId: string) => void;
}

export const ReturnQueue: React.FC<ReturnQueueProps> = ({ orders, onSelectReturn }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.heading}>Return Queue</h3>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>RETURN ID</th>
              <th className={styles.th}>ORDER #</th>
              <th className={styles.th}>CUSTOMER NAME</th>
              <th className={styles.th}>REASON</th>
              <th className={styles.th}>STATUS</th>
              <th className={styles.th}>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className={styles.row}>
                <td className={styles.td}>{order.returnId}</td>
                <td className={styles.td}>{order.orderNumber}</td>
                <td className={styles.td}>{order.customerName}</td>
                <td className={styles.td}>{order.reason}</td>
                <td className={styles.td}>
                  <span
                    className={
                      order.status === 'Pending'
                        ? styles.badgePending
                        : styles.badgeCompleted
                    }
                  >
                    {order.status}
                  </span>
                </td>
                <td className={styles.td}>
                  <button
                    className={
                      order.status === 'Pending'
                        ? styles.btnProcess
                        : styles.btnViewDetails
                    }
                    onClick={() => onSelectReturn(order.returnId)}
                  >
                    {order.status === 'Pending' ? 'Process Return' : 'View Details'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
